import {observer} from 'mobx-react';
import {withState, t} from 'shared/core';
import {PolicyEditFlowState, steps} from '../state';
import {Flow} from 'main/components';
import {policiesRootPath} from 'main/containers/time_tracking/paths';
import {Steps} from './steps';

const PolicyEditFlow = observer(({uiState}) => {
  const {policy, match} = uiState;

  return (
    <Flow
      name={policy.name || t('time_tracking.manage.policies.Untitled policy')}
      backTitle={t('time_tracking.manage.Policies')}
      backRoute={policiesRootPath()}
      steps={steps}
      component={Steps}
      uiState={uiState}
      baseUrl={`/policies/${match.params.id}/edit`}
      onStepSubmitted={step => uiState.onStepSubmitted(step)}
      onStepChanged={step => uiState.onStepChanged(step)}
    />
  );
});

export default withState(PolicyEditFlow, PolicyEditFlowState);
